// extracted by mini-css-extract-plugin
module.exports = {"body":"TextAddShop_body__3Rumy"};